import React, { Fragment, useEffect,useState } from "react";
import { Link, useNavigate } from 'react-router-dom'
import axios from "axios";
import { api, rules,sportlist } from "../../apis/urls";
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import moment from "moment";
import { message } from "antd";
import { Button, Popconfirm } from 'antd';
import { decode } from "html-entities";
import { Loader } from "rsuite";


const RulesList = () => {

    useEffect( ()=>{
        $('body').removeClass('').addClass('sidebar-collapsed');
        $('html,body').animate({ scrollTop: 0 }, 'fast');
        setLoader(true);
        //$('body').removeClass('sidebar-collapsed sidebar-active').addClass('');

        setTimeout(() => {
            Listing();
           
        });

    },[])

    let navigate = useNavigate();

    const [pageno, setPageno] = useState(0);

    const [loader,setLoader] = useState(false);
    const [result,setResult] = useState([]);
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);   
    const [searchTitle, setSearchTitle] = useState("");

    let token = "Bearer "+localStorage.getItem('token');
    const Listing = () => {
        
        
        const instance = axios.create({

            baseURL: rules+'?page='+pageno+'&size='+10,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            console.log("asasasasa", response.data)

            setResult(response.data.data);
            console.log("response data is",response.data.data);
            setCurrentpage(response.data.currentPage)
            setTotalPages(response.data.totalPages)
            setTotalPages(response.data.totalPages)
            setTotalItems(response.data.totalItems)
            //console.log(response.data.data)
            setLoader(false)
          }).catch((error) =>{
            
            console.log('error',error.message)
            
          });

    }






    const instances = axios.create({
        baseURL: api,
        timeout: 1000000,
        headers: {'authorization': token}
    });

    const findByTitles = name => {
        return instances.get(`rules?search=${name}`);
    };

    const onChangeSearchTitle = (e) => {
        const searchTitle = e.target.value;
        setSearchTitle(searchTitle);
        findByTitles(searchTitle)
        .then(response => {

            if(response.data.message=== "Success"){
                setResult(response.data.data);
                setCurrentpage(response.data.currentPage)
                setTotalPages(response.data.totalPages)
                setTotalPages(response.data.totalPages)
                setTotalItems(response.data.totalItems)
            }else{
                setResult(false)
            }
        })
        .catch(e => {
            console.log(e);
        });
    };

    const handleRowClick = (itemid) => {
        let token = "Bearer "+localStorage.getItem('token');
        const data = {
           ruleid:itemid
        }
        console.log('all datas',data)
        const instance = axios.create({

            baseURL: rules+"/duplicaterules",

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.patch('',data).then((response) =>{

            console.log("res data",response.data.message)

            if(response.data.message === "Success")
            {
                window.location.reload();
            }
            
            let path = 'newPath'; 
            navigate("/rules")
           
          }).catch((error) =>{
            
            
            

          });
    };








    //PAGINATION


     // Invoke when user click to request another page.
     const handlePageClick = (event) => {

    setPageno(event.selected)

    $('html,body').animate({ scrollTop: 0 }, 'fast');


     const instance = axios.create({
         baseURL: rules+'?search='+searchTitle+'&page='+event.selected+'&size='+10,
         timeout: 1000000,
         headers: {'authorization': token}
       });

       

     instance.get('').then(response => {

        if(response.data.message=== "Success"){
            setResult(response.data.data);
            setCurrentpage(response.data.currentPage)
            setTotalPages(response.data.totalPages)
            setTotalPages(response.data.totalPages)
            setTotalItems(response.data.totalItems)
        }else{
            setResult(false)
        }
     
        // setLoader(false);
     }).catch(e => {
     //console.log('errorshw',e);
     localStorage.removeItem('token')
     navigate("/")
     });




     // const newOffset = (event.selected * 10) % items.length;
     // console.log(
     // `User requested page number ${event.selected}, which is offset ${newOffset}`
     // );
     // setItemOffset(newOffset);
 };


 let onPublish = (rid,name) => {

        

        let token = "Bearer "+localStorage.getItem('token');

        const datas = {
            publish_status:"PUBLISHED"
        }
        
        const instance = axios.create({
            baseURL: rules+'/publish/'+rid,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.patch('',datas).then((response) =>{    
            message.success(name+ ' rule published successfully')
            Listing();
        }).catch((error) =>{     
            console.log('error',error.message)  
        });
 }

 let onPending = (rid) => {



        let token = "Bearer "+localStorage.getItem('token');

        const datas = {
            publish_status:"PENDING"
        }
        
        const instance = axios.create({
            baseURL: rules+'/publish/'+rid,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.patch('',datas).then((response) =>{
            Listing();
            
        }).catch((error) =>{     
            console.log('error',error.message)  
        });
 }



 
 const confirm = (id, rule_name) =>
 new Promise((resolve) => {
   setTimeout(() => resolve(null), 3000);

    onPublish(id, rule_name)

 });

    let sl=1;
    return(
        <div>
            <aside class="right-side areas">
                <div class="content-area dash-contentss">

                <div class="page-title-wrpr">
                    <div class="page-title-left-column">
                        <h2 class="page-title"> Rules Tests</h2>
                    </div>
                    <div class="page-rightside-action-column">
                    <div class="input-groups mt-3 mb-3 search-grps">
                        <input type="text" 
                        class="form-controls search-bar asso-search"             
                        // value={searchTitle}
                        onChange={onChangeSearchTitle}
                        placeholder="Search" />
                        <button  class="btn btn-search icon-search assosearch-btn"></button>
                        </div>
                        <Link to="/add_rules" data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New School"><i class="icon-add"></i><span>Add Test</span> </Link>

                    </div>
                </div>


                    <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li class="breadcrumb-item active" aria-current="page">Rules Tests</li>
                    </ol>
                    </nav>

                    <div>
                        <div class="containers" style={{overflow:'auto'}}>

                        {result?
                            <table class="table table-rules">
                                <thead>
                                    <tr className="rules-table-head">
                                    <th scope="col">Sl.No</th>
                                    <th scope="col" style={{minWidth:'250px'}}>Rules Test</th>
                                    <th scope="col">Sports</th>
                                    { /*<th scope="col">Charge</th>*/}
                                    <th scope="col" style={{minWidth:'155px'}}>Pass %</th>
                                    <th scope="col" style={{minWidth:'135px'}}>Test Closes</th>
                                    <th scope="col" style={{minWidth:'135px'}}>Created Date</th>
                                    <th scope="col" style={{textAlign:'center'}}>Actions</th>

                                    </tr>
                                </thead>
                                <tbody className="rules-table-content">
                                        <Fragment>
                                        {result?.map((item,index) =>(

                                            <tr style={{background:item.publish_status === 'PENDING'?'#f0f0f0':'#fff'}}>
                                                <td scope="row">{(index+1)+currentpage*10}</td>
                                                <td>{decode(item.rule_name)}</td>
                                                <td>{item.sport_name}</td>
                                                { /*<td>${item.amount}</td> */ }
                                                <td>{item.min_mark}</td>
                                                <td>{moment(item.test_lastDate).format('MM-DD-YYYY')}</td>
                                                <td>{moment(item.createdAt).format('MM-DD-YYYY')}</td>
                                                <td>



                                                    <div className="list-action-wrpr showicons roundicons-text">
                                                        <div className="list-action-wrpr">

                                                        <div style={{width:'10px'}} />
                                                        <button class="copy" style={{top:"-20px"}}  onClick={() => handleRowClick(item.id)} data-toggle="tooltip" title="Duplicate">
                                                            <i class="icon-copy" style={{background:'orange'}}></i>
                                                            <span>Duplicate</span>
                                                        </button>
                                                        <div style={{width:'10px'}} />

                                                        {
                                                           item.publish_status === 'PENDING'? 
                                                        
                                                       (
                                                            <Popconfirm
                                                            title={item.coachData === 0?"Add one or more question":"Do you want to publish this rule"}
                                                            description="Open Popconfirm with Promise"
                                                            onConfirm={()=>item.coachData === 0?null:confirm(item.id, item.rule_name)}
                                                            onOpenChange={() => console.log('open change')}
                                                            >

                                                                <button style={{top:"-20px"}} data-toggle="tooltip" title="Publish" id={item.id}>
                                                                    <i class="icon-publish"></i>
                                                                    <span>Publish</span>
                                                                </button>

                                                            </Popconfirm>
                                                       ) :
                                                        (


                                                            <Popconfirm
                                                            title={"Do you want to unpublish this rule"}
                                                            description="Open Popconfirm with Promise"
                                                            onConfirm={()=>onPending(item.id, item.rule_name)}
                                                            onOpenChange={() => console.log('open change')}
                                                            >

                                                            <button style={{top:"-20px"}} data-toggle="tooltip" title="Published" id={item.id}>
                                                                <i class="icon-tick" style={{background:'#0068ff'}}></i>
                                                                <span>Published</span>
                                                            </button>


                                                            </Popconfirm>

                                                        )
                                                        }

                                                       

                                                        <div style={{width:'10px'}} />
                                                        <button style={{top:"-20px"}}  onClick={()=>{navigate("/rules_list_question/"+item.id)}} data-toggle="tooltip" title="Questions">
                                                            <i class="icon-question" style={{background:'orange'}}></i>
                                                            <span>Questions</span>
                                                        </button>

                                                        <div style={{width:'10px'}} />
                                                        <button style={{top:"-20px"}}  onClick={()=>{navigate("/rule_coach/"+item.id)}} data-toggle="tooltip" title="Coaches">
                                                            <i class="icon-user2 data-counts-icon"  style={{background:'green'}} data-count={item.coachpasscount}></i>
                                                            <span>Coaches</span>
                                                        </button>

                                                        <div style={{width:'10px'}} />

                                                        <button style={{top:"-20px"}}  onClick={()=>{navigate("/rule_view/"+item.id)}} data-toggle="tooltip" title="View">
                                                            <i class="icon-eye" style={{background:'black'}}></i>
                                                            <span>&nbsp;View&nbsp;</span>
                                                        </button>

                                                       

                                                    </div>
                                                    </div>
                                                </td>
                                            
                                            </tr>
                                        ))}
                                        </Fragment>

                                </tbody>   
                                

                            </table>
                            :null
                        } 


                                {
                                    !result?
                                    (
                                        <div className="nodata" style={{marginTop:'100px'}}>
                                            <h2>Sorry! No Rules Found</h2>
                                        </div>
                                    ):null
                                }    

                    </div>


                            { 
                                loader?
                                <div>
                                    <div className="loader_container"><Loader /></div>
                                </div>
                                :
                                null
                            }




                            {
                            result?
                            <div class="pagination-wrpr">
                                    <ReactPaginate
                                            className="pagination page"
                                            pageClassName="page-item"
                                            activeClassName="active"
                                            nextLabel=">"
                                            previousLabel="<"
                                            previousClassName="page-link p-link"
                                            nextClassName="page-link p-link"
                                            onPageChange={handlePageClick}
                                            pageRangeDisplayed={10}
                                            pageCount={totalPages}
                                            renderOnZeroPageCount={null}
                                        />
                                </div>:null}

                    </div>
                </div>
            </aside>
        </div>

    )
}

export default RulesList;